import { SCHOOL_SUBJECTS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const SchoolSubjectsExporter = createExporter(
  `${SCHOOL_SUBJECTS}.xlsx`,
  [
    { key: "nameBg", label: "име на български" },
    { key: "nameEn", label: "име на английски" },
  ],
  record => ({
    ...record,
  }),
);
